<script lang="ts">

</script>

<nav class="navbar navbar-expand-lg navbar-light bg-light rounded">
    <div class="container-fluid">
        <a class="navbar-brand" href="#!">
            <img src="/images/smartwash-logo.webp" alt="" width="40" height="32"
                 class="d-inline-block align-text-top">
            The Smart Wash
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
    </div>
</nav>